import React from 'react'
import { LoginDialog } from './login/login_dialog.component'

import { LoginEmailDialog } from './login/login_email_dialog.component'
import { LoginPhoneDialog } from './login/login_phone_dialog.component'
import { LoginEmailRegister } from './login/login_email_register.component'
import { LoginClientCallDialog } from './login/login_client_call.component'

import singletons from '../shared/singletons'

import { sharedData } from '../../models/shared_data.js'

export class LoginButton extends React.Component {
  constructor(props) {
    super(props)

    this.click = this.click.bind(this)
    this.clickLogin = this.clickLogin.bind(this)
    this.clickRegister = this.clickRegister.bind(this)

    this.onClose = this.onClose.bind(this)
    this.state = {
      openedLogin: false,
      openedRegister: false,
      title: 'Личный кабинет',
      phone: null
    }

    singletons['login'] = this
  }

  enterText() {
    if(this.props.enterText)
      return this.props.enterText
    return 'Войти'
  }

  close() {
    this.setState({
      openedLogin: false,
      openedRegister: false
    })
  }

  toggleRegister() {
    this.setState({
      openedRegister: !this.state.openedRegister
    })
  }

  toggleLogin(phone = null) {
    if(phone)
      this.setState({
        openedLogin: !this.state.openedLogin,
        phone: phone,
        title: 'Подтверждение номера',
        reload: false
      })
    else
      this.setState({
        openedLogin: !this.state.openedLogin,
        phone: null,
        title: 'Личный кабинет',
        reload: true
      })
  }

  open(phone = null) {
    this.toggleLogin(phone)
  }

  click(e) {
    if(e)
      e.preventDefault()
    this.toggle()
  }

  clickLogin(e) {
    if(e)
      e.preventDefault()
    this.toggleLogin()
  }

  clickRegister(e) {
    if(e)
      e.preventDefault()
    this.toggleRegister()
  }

  onClose() {
    this.close()
  }

  render() {
    const sp = sharedData.data.site_params
    const enterText = this.enterText()
    return (
      <div className={sp.client_login_type == 'email' ? "login-header-links login-button" : 'login-button'}>

        <a href='' onClick={this.clickLogin}>
          {enterText}
        </a>
        {sp.client_login_type == 'email' &&
          <a href='' onClick={this.clickRegister}>
            Регистрация
          </a>
        }
        {  sp.client_login_type == 'sms' && (this.state.openedLogin || this.state.openedRegister) &&
          <LoginDialog ttl={this.state.title} reload={this.state.reload} phone={this.state.phone} onClose={this.onClose}></LoginDialog>
        }

        {  sp.client_login_type == 'phone' && (this.state.openedLogin || this.state.openedRegister) &&
          <LoginPhoneDialog ttl={this.state.title} reload={this.state.reload} phone={this.state.phone} onClose={this.onClose}></LoginPhoneDialog>
        }

        { sp.client_login_type == 'client_call' && (this.state.openedLogin || this.state.openedRegister) &&
          <LoginClientCallDialog ttl={this.state.title} reload={this.state.reload} phone={this.state.phone} onClose={this.onClose}></LoginClientCallDialog>
        }



        {  sp.client_login_type == 'email' && this.state.openedLogin &&
          <LoginEmailDialog onClose={this.onClose}></LoginEmailDialog>
        }
        {  sp.client_login_type == 'email' && this.state.openedRegister &&
          <LoginEmailRegister onClose={this.onClose}></LoginEmailRegister>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/react/profile/login_button.component.jsx